var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"real-video-dimensions-reference-overlay-container",style:({
    width: _vm.idealSize.width,
    height: _vm.idealSize.height,
    left: _vm.idealSize.offsetLeft,
    top: _vm.idealSize.offsetTop,
  }),attrs:{"id":"videoDimensionsReference"}})
}
var staticRenderFns = []

export { render, staticRenderFns }